import React from 'react'
import { Helmet } from 'react-helmet'
import Footer from './Footer'
import Header from './Header'
import ReactGA from "react-ga4";

const Layout = ({ children, title, description, keywords, image="", productTag="" }  ) => {
  const TRACKING_ID = 'G-VNQJ86ZD9G'
  ReactGA.initialize(TRACKING_ID);
  ReactGA.send({ hitType: "pageview", page: document.location.pathname, title: title });
  const currentUrl = typeof window !== "undefined" ? window.location.href : "";
  //console.log(productTag)
  return (
    <>
    <Helmet>
        <meta charSet="utf-8" />
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <meta name="title" content={title} />
        <title>{title}</title>

        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={currentUrl} />
        <meta property="og:image" content={image} />
        <meta property="og:image:secure_url" content={image} />
        
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={image} />

        {productTag?.id !=='' &&
        <meta property="product:sku" content={productTag.id} />
        }
        {productTag?.availability !=='' &&
        <meta property="product:availability" content={productTag.availability} />
        }
        {productTag?.amount !==0 &&
        <meta property="product:price:amount" content={productTag.amount} />
        }
        {productTag?.currency !=='' &&
        <meta property="product:price:currency" content={productTag.currency} />
        }
       
    </Helmet>
    <Header/>
        {children}
    <Footer />    
    </>
  )
}

Layout.defaultProps = {
  description : "Abode of designer Lehengas, Gowns, Sarees, Indo Westerns and Western Dresses. SHIPPING WORLDWIDE.",
  keywords : "Chaashni",
  title : "Chaashni by Maansi & Ketan",
  image : "https://chaashnicouture.com/images/chaashnicouture.jpg"
}

export default Layout
